module.exports = __webpack_public_path__ + "static/media/bkg04n.5ac722a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg04n.jpg
// module id = 470
// module chunks = 0